import React from "react";
import { Outlet } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";

const MainLayout = ({
  lang,
  setLang,
  textData,
  ticker,
  pdfArticles,
  imageVersion,
}) => (
  <div className="min-h-screen flex flex-col bg-gray-50">
    <Header lang={lang} setLang={setLang} textData={textData} ticker={ticker} />
    <Outlet />
    <Footer textData={textData} pdfArticles={pdfArticles} />
  </div>
);

export default MainLayout;
